import { useState } from "react";
import { SliderContainer } from "../../components/swipper/SliderContainer";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faShareSquare } from "@fortawesome/free-solid-svg-icons";
import ImageAsync from "../../components/native/ImageAsync";

const GalleryVisualizer = ({ gallery, onclose, init = 0 }) => {

    const icons = {
        backwhite: <FontAwesomeIcon icon={faChevronLeft} color='#ffffff' />,
        share: <FontAwesomeIcon icon={faShareSquare} color='#ffffff' />
    }

    const [slide, setSlide] = useState(1);

    return (
        <div className="gallery-view-container flex flex-col justify-between items-center">

            <div className="text-white w-full flex justify-between items-center px-4 pt-4">
                <div onClick={onclose}>
                    {icons.backwhite}
                </div>
                <div>
                    {slide} / {gallery.length}
                </div>
                <div>
                    {icons.share}
                </div>
            </div>

            <div className="text-white w-full">
                <SliderContainer
                    sliderclass="slider_elem_style"
                    contentclass="sliderstyle"
                    currentSlide={(e) => { setSlide(e + 1) }}
                    initial={init}
                >

                    {
                        gallery.map((image, index) => {
                            return (
                                <ImageAsync key={index} src={image.imageUrl} alt={"gallery " + (index + 1)} />
                            )
                        })
                    }

                </SliderContainer>
            </div>


            <div>
                0
            </div>

        </div>
    )
}

GalleryVisualizer.propTypes = {
    gallery: PropTypes.array,
    onclose: PropTypes.func
}

export default GalleryVisualizer;
